interface ApiConfigSchema{
    url:{
        portal:string;
        authorisation:string;
        medicationsManagement:string;
        healthIdentifier:string;
    },
    featureFlags?: {qrcode: boolean;}
};
let ApiConfig:ApiConfigSchema;

export function configureApi(settings:any){
    ApiConfig= {
        url:{
            portal:settings.apiEndpoints.portal,
            authorisation:settings.apiEndpoints.authorisation,
            medicationsManagement:settings.apiEndpoints.medicationsManagement,
            healthIdentifier:settings.apiEndpoints.healthIdentifier,
            
        },
        featureFlags: {qrcode: settings.featureFlags?.qrcode}
    }; 
}

export function getApiConfig(){
    return ApiConfig;
};